import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SiteLayout } from "@/components/site/SiteLayout";
import { ArticleCard } from "@/components/site/ArticleCard";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!q) return;
    setLoading(true);
    api.get("/articles", { params: { search: q, limit: 30 } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); })
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <SiteLayout>
      <div className="max-w-[1240px] mx-auto px-4 py-8">
        <header className="border-b-2 border-prussian pb-4 mb-8">
          <p className="text-xs uppercase tracking-wider text-gold font-body font-bold">Suchergebnisse</p>
          <h1 className="font-headline font-black text-prussian text-3xl md:text-4xl mt-1">„{q}"</h1>
          <p className="text-sm text-muted-foreground font-body mt-2">{total} Treffer</p>
        </header>
        {loading ? (
          <p className="text-muted-foreground font-body py-12 text-center">Suche läuft…</p>
        ) : items.length === 0 ? (
          <div className="py-16 text-center">
            <p className="text-muted-foreground font-body">Keine Artikel gefunden.</p>
            <Link to="/" className="text-gold-hover font-body mt-3 inline-block">Zur Startseite</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((a) => <ArticleCard key={a.id} article={a} />)}
          </div>
        )}
      </div>
    </SiteLayout>
  );
}
